import {fetch} from "utils/dataAccess";

export async function stopMission(task, member) {
    const response = await fetch(`/w_m_s_tasks/stop/${task.id}`, {
        method: "PATCH",
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: JSON.stringify({
            member: "/members/"+member.id
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to stop mission with ID ${task.id} and member ${member.id} : ${response.statusText}`);
    }

    return response.json();
}
